import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import NavigationSidebar from "components/ui/NavigationSidebar";
import { PAGE_MAIN_CLASS } from "components/layout/PageContent";
import { TutorialProvider } from "features/tutorial/TutorialContext";

const MOBILE_SIDEBAR_MQ = "(max-width: 1023px)";

const AppLayout = () => {
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);
    const [forceDocumentsOpen, setForceDocumentsOpen] = useState(false);
    const [forceCrmOpen, setForceCrmOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        if (window.matchMedia(MOBILE_SIDEBAR_MQ).matches) {
            setIsSidebarCollapsed(true);
        }
    }, [location.pathname]);

    return (
        <TutorialProvider
            setSidebarCollapsed={setIsSidebarCollapsed}
            setForceDocumentsOpen={setForceDocumentsOpen}
            setForceCrmOpen={setForceCrmOpen}
        >
            <NavigationSidebar
                isCollapsed={isSidebarCollapsed}
                onToggle={() => setIsSidebarCollapsed((v) => !v)}
                onCloseMobile={() => setIsSidebarCollapsed(true)}
                forceDocumentsOpen={forceDocumentsOpen}
                forceCrmOpen={forceCrmOpen}
            />

            <main className={PAGE_MAIN_CLASS}>
                <Outlet />
            </main>
        </TutorialProvider>
    );
};

export default AppLayout;
